import context from './context';
import { EventEmitter } from 'events';

class App extends EventEmitter {
  constructor () {
    super();
    this.initialized = false;
  }

  isInitialized () {
    return this.initialized;
  }

  init (options) {
    options = options || {};

    if (this.isInitialized()) {
      throw new Error('InteractiveSolutions authentication has already been initialized');
    }

    this.initialized = true;

    context.store = options.store;
    context.endpoints = options.endpoints || {};

    this.emit('ready');
  }
}

export default new App();



/** WEBPACK FOOTER **
 ** ./src/interactive-solutions/authentication/app.js
 **/